import script from "./medicalHistoryInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./medicalHistoryInfo.vue?vue&type=script&setup=true&lang=js"

import "./medicalHistoryInfo.vue?vue&type=style&index=0&id=6ec3fae7&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec3fae7"]])

export default __exports__